import { getFeedPickerConfig } from './feedPickerConfig';

const NONE_NEED = 'Пропустить';

export function sanitizeParams(params = {}) {
    const p = { ...params };

    // чистим undefined/null/пустые строки
    Object.keys(p).forEach((k) => {
        const v = p[k];
        if (v === undefined || v === null) delete p[k];
        if (typeof v === 'string' && v.trim() === '') delete p[k];
    });

    const toArray = (val) => {
        if (val === undefined || val === null) return [];
        return Array.isArray(val) ? val : [val];
    };

    // эти поля у вас реально могут быть множественными
    if ('types' in p) p.types = toArray(p.types).filter(Boolean);
    if ('brands' in p) p.brands = toArray(p.brands).filter(Boolean);
    if ('taste' in p) p.taste = toArray(p.taste).filter(Boolean);
    if ('special_needs' in p) p.special_needs = toArray(p.special_needs).filter(Boolean);
    if ('textures' in p) p.textures = toArray(p.textures).filter(Boolean);

    return p;
}
export function normalizeForApi(params = {}) {
    const p = { ...params };

    // коты -> всегда pet_size=cat
    if (p.pet_type === 'cat') {
        p.pet_size = 'cat';
    }

    if (Array.isArray(p.special_needs)) {
        const set = new Set(p.special_needs.map(String));
        if (set.has(NONE_NEED)) {
            delete p.special_needs;
        }
    }

    if (Array.isArray(p.textures)) {
        const set = new Set(p.textures.map(String));
        if (set.has(NONE_NEED)) {
            delete p.textures;
        }
    }

    return p;
}

export function ensureDefaultTasteAndBrands(rawParams = {}) {
    const cfg = getFeedPickerConfig();
    const p = { ...rawParams };

    const tastes = Array.isArray(cfg.tastes) ? cfg.tastes : [];

    // taste: если нет выбора - отправляем все доступные
    if (!Array.isArray(p.taste) || p.taste.length === 0) {
        p.taste = [...tastes];
    }

    // brands: если нет выбора - отправляем дефолтный набор
    if (!Array.isArray(p.brands) || p.brands.length === 0) {
        p.brands = ['pro_plan', 'purina_one'];
    }

    return p;
}
